module.exports = __webpack_public_path__ + "static/media/germany.69058c82.svg";